import { loadConfig } from './config/config'

const startupErrorMessage =
  'Não foi possível carregar a configuração da aplicação. Tente novamente mais tarde.'

loadConfig()
  .then(() => import('./bootstrap'))
  .catch((error) => {
    console.error('Failed to start the application', error)
    const root = document.getElementById('root')
    if (root) {
      root.textContent = startupErrorMessage
    }
  })
